import React, { useState } from "react";
import Button from "pages/_components/Button";
import Drawer from "pages/_components/Drawer/Drawer";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import { useCopyToClipBoard } from "hooks/useCopyToClipBoard";
import gaEventTracker, { events } from "util/gaEventTracker";
import CustomText from "pages/_components/CustomText/CustomText";
import { isIOS, isMobile } from "react-device-detect";
import { customDetailAccountPropType, defaultCustomDetailAccountPropType } from "./customDetailAccountPropType";
import AccountDetails from "./AccountDetails";

const productTypes = { CA: "savings", CC: "checking", CE: "specialChecking", CBB: "CBB"};

const CustomDetailAccount = (props) => {
    const { account, openQr, isDesktop } = props;
    const { accountNumber, productType, cbuAlias } = account;
    const [isVisible, setShow] = useState(false);

    const copyData = {
        productType: `${i18n.get(`accounts.productType.${productTypes[account.productType]}`)} en ${account.currency}`,
        cbu: account.uniformBankCode,
        owner: account.owner,
        accountNumber: account.accountNumber,
        alias: account.cbuAlias,
        cuit: account.taxBankCode,
    };
    const { handleCopyToClipBoard } = useCopyToClipBoard(isDesktop, "account.details.textCopy", copyData);

    const [openSidebar, setOpenSidebar] = useState(false);
    const numberMasked = ` Nº ····${accountNumber?.slice(-4)}`;

    const handleShare = () => {
        gaEventTracker.triggerEvent(events.cuentas_detalle_compartir());
        handleCopyToClipBoard("account/details");
    };
    const handleShow = () => {
        setShow(!isVisible);
    };
    const handleQr = () => {
        gaEventTracker.triggerEvent(events.cuentas_detalle_QR());
        openQr();
    };
    const handleShowMore = () => {
        gaEventTracker.triggerEvent(events.cuentas_info_detalle());
        setOpenSidebar(true);
    };

    return (
        <>
            <GridTable className="account-info">
                <GridTable.Container>
                    <div className="grid-table-data" style={{ flexDirection: "row" }}>
                        <div
                            className="custom-data"
                            style={{
                                flex: "initial",
                                paddingRight: "10px",
                                width: "max-content",
                                wordBreak: "break-all",
                            }}>
                            <CustomText
                                text={`accounts.productType.${productTypes[productType]}`}
                                textType="I18N"
                                keepSpaceIfNoText
                                className="custom-data-title whitespace-nowrap"
                            />
                            <CustomText
                                text={isVisible ? `Nº ${accountNumber}` : numberMasked}
                                keepSpaceIfNoText
                                className="custom-data-value"
                            />
                        </div>
                        <Button
                            bsStyle="link"
                            image={isVisible ? "images/figma/icon/eye.svg" : "images/figma/icon/eyehide.svg"}
                            className="link"
                            block={false}
                            onClick={handleShow}
                            style={{
                                flex: 1,
                                justifyContent: "flex-start",
                                alignItems: "flex-end",
                                minWidth: "fit-content",
                            }}
                        />
                    </div>
                    <GridTable.Data
                        className="bank-code"
                        columnStart={!isDesktop ? 1 : null}
                        columnWidth={!isDesktop ? 2 : null}>
                        <CustomData
                            titleText="accounts.details.information.cbu.label"
                            titleTextType="I18N"
                            valueText={account.uniformBankCode}
                            titleClass="primary"
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop && 3}>
                        <CustomData
                            titleText={cbuAlias && "accounts.details.information.alias.label"}
                            titleTextType="I18N"
                            valueText={cbuAlias}
                            titleClass="primary"
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={1} className="isVisible-share">
                        <Button
                            bsStyle="link"
                            image="images/figma/icon/share-primary.svg"
                            label="global.share"
                            className="link"
                            block={false}
                            onClick={handleShare}
                        />
                    </GridTable.Data>
                    <GridTable.Data className="isVisible-qr" alignX={!isDesktop ? "right" : null}>
                        <Button
                            bsStyle="link"
                            className="link"
                            image="images/figma/icon/qr-primary.svg"
                            label="accounts.details.showQr"
                            block={false}
                            onClick={handleQr}
                        />
                    </GridTable.Data>
                    <GridTable.Data className="view-more">
                        <Button
                            bsStyle="link"
                            className="link"
                            label="global.showMore"
                            image="images/figma/icon/arrow.svg"
                            block={false}
                            onClick={handleShowMore}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
            <Drawer
                isFullHeight={isMobile || isIOS}
                openSidebar={openSidebar}
                enableCloseButton={!!isDesktop}
                toggleSidebar={setOpenSidebar}
                {...props}>
                <AccountDetails account={account} openQr={openQr} toggleSidebar={setOpenSidebar} />
            </Drawer>
        </>
    );
};

CustomDetailAccount.propTypes = customDetailAccountPropType;
CustomDetailAccount.defaultProps = defaultCustomDetailAccountPropType;

export default CustomDetailAccount;
